import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ParticipantLangModalComponent} from './participant-lang-modal.component';
import {AlertMessageModule} from "../../lib/alert-message/alert-message.module";
import {FormsModule} from "@angular/forms";
import { BannerModule } from '@xref/xref-lib';
import { ButtonModule } from '@xref/xref-lib';
@NgModule({
  declarations: [ParticipantLangModalComponent],
  imports: [
    CommonModule, FormsModule,
    AlertMessageModule,
    BannerModule,
    ButtonModule
  ],
  exports: [ParticipantLangModalComponent]
})
export class ParticipantLangModalModule { }
